import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Header extends Vue {
   public title: string = 'Header';

   public sections = [
      'detail',
      'sendnotice'
   ];

   public sectionSelected = 'detail';

   public onSelect(value: string) {
      this.onSelectCallBack(value);
      this.sectionSelected = value;
   }

   @Prop()
   public onSelectCallBack: any;
}
